import dynamic from 'next/dynamic'

import AdditionalInfo from '../AdditionalInfo'
import PaymentInfo from '../PaymentInfo'
import ShippingReturnRules from '../ShippingReturnRules'

const Collapse = dynamic(() => import('app/components/base/Collapse'), {
  ssr: true
})

const Description = dynamic(() => import('../Description'), {
  ssr: true
})

export {
  AdditionalInfo,
  Description,
  PaymentInfo,
  ShippingReturnRules,
  Collapse
}
